import Image from "next/legacy/image";

import * as S from "./style";
import * as D from "./data";

export default function Template() {
  return (
    <S.Wrapper>
      <S.ContentsWrapper>
        <section>
          <S.SubTitle>
            <D.SubTitle />
          </S.SubTitle>
          <S.Title>
            <D.Title />
          </S.Title>
          <S.Desc>
            <D.Desc />
          </S.Desc>
        </section>
        <S.ImageWrapper>
          <Image
            alt={"hero"}
            layout="fill"
            objectFit="cover"
            objectPosition="center"
            priority={true}
            src={`${process.env.CDN_BASE_URL}/swcamp/landing_hero.png`}
          />
        </S.ImageWrapper>
        {/* <S.Desc>
          <D.Desc />
        </S.Desc> */}
      </S.ContentsWrapper>
    </S.Wrapper>
  );
}
